export default __webpack_public_path__ + "static/media/icon_profilesettings_dashboard.c3977bf9.svg";